module.exports = __webpack_public_path__ + "img/time-to-sign.16b635bd.png";